__webpack_require__.p = "/wordle-game/";